/* eslint-disable react/display-name */
import PropTypes from 'prop-types';
import React from 'react';
import { Grid } from '@material-ui/core';
import { useStyles } from './RulerPopupUseStyles';

const RulerPopup = React.forwardRef((props, ref) => {
  const classes = useStyles(props);
  const { distance, unit } = props;

  return (
    <div
      ref={ref}
      id="popup"
      className={`${classes.RulerPopup} ${classes.RulerPopupCalc}`}
    >
      <div>
        <Grid container id="popup-content">
          <Grid className={`${classes.RulerPopup}__text--color`} item xs={12}>
            {distance} {unit || 'km'}
          </Grid>
        </Grid>
      </div>
    </div>
  );
});
RulerPopup.propTypes = {
  distance: PropTypes.number.isRequired,
  unit: PropTypes.string,
};

export default RulerPopup;
